import React, {useState, useEffect, useContext} from 'react'
import UserContext from '../../context/context'
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { history } from '../../_helpers';

import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
// convertToRaw로 변환시켜준 원시 JS 구조를 HTML로 변환.
import draftToHtml from 'draftjs-to-html';

function SingleRa(){
  const [state, actions] = useContext(UserContext);
  const [ra, setRa] = useState(null)
  const [singleApply, setSingleApply] = useState()
  const [resume, setResume] = useState()
  const [companyInfo, setCompanyInfo] = useState()

  const [whichResume, setWhichResume] = useState()
  const [fileList, setFileList] = useState()
  const [whichFile, setWhichFile] = useState()
  const [whichDB, setWhichDB] = useState()
  const [userid, setUserid] = useState()

  const [applycheck, setApplycheck] = useState(false)

  const [editorToHtml, setEditorToHtml] = useState(EditorState.createEmpty())
  
  
  const [resumenum, setResumenum] = useState(0)
  const [filenum, setFilenum] = useState(0)

  const [infohh, setInfohh] = useState()

  let user = JSON.parse(String(localStorage.getItem('user')))
  
  let header = {}

  if(user){
    header = {Authorization: `JWT ${user.token}`}
  } else{
    header = {}
  }

  let ra_id = history.location.pathname.split('/')[3]
  let ra_title = history.location.pathname.split('/')[4]

  
  // console.log(history.location.pathname.split('/')[2])
  // const re_id = history.location.pathname.split('/')[2]

  function fetchApply(){
    fetch(state.awslink + "/api/apply/", {
      method: 'POST',
      headers: header,
      body:JSON.stringify({
        "id": ra.id,
        "resume_id": whichResume,
        "filename": whichFile,
        "status": ra.status
      })
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
      })
  }

  function fetchAccept(step){
    fetch(state.awslink + "/api/recartshop/", {
      method: 'PUT',
      headers: header,
      body:JSON.stringify({
        "id": ra.id,
        "step": step,
        "status": ra.status,
        "userid": userid,
        "which": whichDB
      })
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
      })
  }

  
  useEffect(()=>{
    async function fetchRa(){
      fetch(state.awslink + "/api/generalra/?id=" + ra_id + "&title=" + ra_title, {
      method: 'GET',
      // headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        // let parsed = EditorState.createWithContent(convertFromRaw(JSON.parse(json.description))) 

        // setEditorToHtml(draftToHtml(convertToRaw(parsed.getCurrentContent())))
        let parsed = EditorState.createWithContent(convertFromRaw(JSON.parse(json.description))) 
        setEditorToHtml(draftToHtml(convertToRaw(parsed.getCurrentContent())))
        setRa(json)

        if(json.status === "7%"){
          fetch(state.awslink + "/user/company/?id=" + json.company["id"], {
            method: 'GET',
            // headers: header,
          })
          .then(response => response.json())
          .then(json=>{
            console.log(json)
            setCompanyInfo(json)
          })
        }
        else{
          if(json.companyPublic){

          }
          else{
            
          }
          fetch(state.awslink + "/user/userIntAbi/?id=" + json.user.id, {
            method: 'GET',
            headers: header,
          })
          .then(response => response.json())
          .then(json=>{
            console.log(json)
            setInfohh(json)
          })
          setCompanyInfo(json.company)
          
        }
      })
    }

    async function fetchApplyById(){
      fetch(state.awslink + "/api/apply/?id=" + ra_id +
      "&title=" + ra_title, {
        method: 'GET',
        headers: header,
        })
        .then(response => response.json())
        .then(json=>{
          console.log(json)
          setSingleApply(json)
          if(json.userSecond){
            setWhichDB("DB2")
            setUserid(json.userSecond.id)
          }
          else{
            setWhichDB("DB1")
            setUserid(json.user.id)
          }
        })
    }
  
    async function fetchResumeData(){
      fetch(state.awslink + "/api/resume/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setResume(json)
        if(json.length){
          setWhichResume(json[0].id)
        }

        
      })
    }

    // async function fetchFileList(){
    //   fetch(state.awslink + "/api/file/", {
    //     method: 'GET',
    //     headers: header,
    //   })
    //   .then(response => {
    //     response.json()
    //     console.log(response.status)
    //   })
    //   .then(json=>{
    //     console.log(json)
    //     if(json==="Key error" || json===undefined){
          
    //     }
    //     else{
    //       setFileList(json)
    //       if(json.length){
    //         setWhichFile(json[0].Key)
    //       }
    //     }
        
    //   })
    // }


    fetchRa();
    if(user){
      fetchApplyById();
      fetchResumeData();
      // fetchFileList();
    }
  },[])

  // console.log(ra)
  // console.log(whichResume, whichFile)
  console.log(fileList)
  // console.log(resume)
  // if(ralist === null){
  //   if(state.token != undefined)
  //     fetchRalist();
  // }
  
  return(
    <>
    {/* {state.width < state.breakpoint ? 
      null
    : */}
      <Wrapper>
        <CompanyWrapper>
          {
            ra? ra.companyPublic && 
              companyInfo?
              <div >
                <div className="logo">
                  <Link to={'/companynlab/' + companyInfo.id}>
                    <img
                      src={companyInfo.user.logolink ? companyInfo.user.logolink : "dummy"}
                      onError={(e)=>{
                        e.target.src = state.noimage
                      }}
                    />
                  </Link>
                </div>

                <div>
                  {companyInfo.title}
                  <Link to={'/companynlab/' + companyInfo.id} />
                </div>
                
                <div>
                  {companyInfo.tag.map((item, index)=>{
                    return(
                      <div>
                        # {item}
                      </div>
                    )
                  })}
                </div>
              </div>
              : 
              infohh &&
              <div >
                <div className="logo">
                  <Link to={'/companynlab/' + infohh.id}>
                    <img
                      src={infohh.profilelink ? infohh.profilelink : "dummy"}
                      onError={(e)=>{
                        e.target.src = state.noimage
                      }}
                    />
                  </Link>
                </div>

                <div>
                  {infohh.realname}
                  <Link to={'/companynlab/' + infohh.id} />
                </div>
              </div>
            : 
            <div >
              <div className="logo">
                <Link 
                // to={'/companynlab/' + companyInfo.id}
                >
                  <img
                    src={state.noimage}
                    onError={(e)=>{
                      e.target.src = state.noimage
                    }}
                  />
                </Link>
              </div>

              <div>
                {/* {companyInfo.title} */}
                비공개회사
                {/* <Link to={'/companynlab/' + companyInfo.id} /> */}
              </div>
              
              <div>
                {companyInfo ? 
                  companyInfo.tag.map((item, index)=>{
                    return(
                      <div>
                        # {item}
                      </div>
                    )})
                    : null
                }
              </div>
            </div>
          }
          
        </CompanyWrapper>
        
        <RaWrapper>
          {ra ?
          <>
          <RaForm>
            <div>
              <div className="main">
                {companyInfo ?
                  <img
                    src={companyInfo.user.mainlink ? 
                      companyInfo.user.mainlink + "?dummy=123": 
                      companyInfo.mainlink ? companyInfo.mainlink : "dummy"}
                    onError={(e)=>{
                      e.target.src = state.noimage
                    }}
                  />: <img src={state.noimage}/>
                }
                
              </div>
              
              <div className={"ra-header"}>
                <h1>{ra.title}</h1>
                {companyInfo && <h4>{companyInfo.title}</h4>}
                
                <p>{ra.created.split('T')[0]}</p>
                {/* <div></div> */}
                <div>
                  <div>{ra.field}</div>
                  {ra.job.map((item, index)=>{
                    return(
                      <div>{item}</div>
                    )
                  })}
                </div>
              </div>
              
              <div className={"ra-body"}>
                {/* <div>{ra.description}</div> */}
                <div dangerouslySetInnerHTML={{__html: editorToHtml}}/>
                
              </div>

              <div className={"ra-field"}>
                <div>
                  <span>근무지</span>
                  <span>{ra.workadd}</span>
                </div>
                <div>
                  <span>마감일</span>
                  <span>{ra.enddate}</span>
                </div>
                <div>
                  <span>예상연봉</span>
                  <span>{ra.salary}</span>
                </div>
                <div>
                  <span>선호경력</span>
                  <span>{ra.workyears}</span>
                </div>
              </div>

            </div>
          </RaForm>

          <RightForm>
            {applycheck?
              resume && resume.length? 
                <AfterRight>
                  <div 
                  onClick={()=>setApplycheck(false)}
                  style={{cursor: "pointer", position:"absolute", top: "10px", right: "10px"}}>
                    뒤로
                  </div>
                  <h3>첨부파일</h3>
                  <ResumeForm>
                    <div>
                      {resume?
                        resume.map((item, index)=>{
                          return(
                            <div className={resumenum===index ? "active": "deactive"} 
                            onClick={()=>{setWhichResume(item.id); setResumenum(index)}}>
                              <div>{item.title}</div>
                              {/* <div>{item.id}</div> */}
                            </div>
                          )
                        })
                        :null
                      }
                    </div>
                    {/* <span></span> */}
                    {/* <div>
                      {fileList?
                        fileList.map((item, index)=>{
                          // console.log(item, index)
                          return(
                            <div className={filenum===index ? "active": "deactive"} 
                              onClick={()=>{setWhichFile(item.Key); setFilenum(index)}}>
                              <div>{item.Key.split('/')[item.Key.split('/').length-1]}</div>
                              <div>{item.LastModified.split('T')[0]}</div>
                              
                            </div>
                          )
                        })
                        :null}
                    </div> */}
                  </ResumeForm>

                {/* <ResumeForm>
                </ResumeForm> */}

                <ButtonForm>
                  {singleApply?
                    <>

                      {singleApply.step === "지원완료" && "지원완료"}
                      {singleApply.step === null && "지원완료"}
                      {/* {singleApply.step === "추천" && "지원완료"} */}
                      {singleApply.step === "최종합격" && null}
                      {singleApply.step === "서류합격" && "서류합격"}
                      {/* {singleApply.step === "장바구니" && 
                      <>"이 회사가 나를 좋아해요!" 
                      <button onClick={()=>{fetchApply(); history.push('/applylist')}}>
                        지원하기
                      </button></>} */}
                      {singleApply.step === "제안보냄" && 
                      <button onClick={()=>{fetchAccept("제안수락"); history.push('/applylist')}}>
                        제안수락
                      </button>}

                      {singleApply.step === "추천제안" && 
                      <button onClick={()=>{fetchAccept("추천수락"); history.push('/applylist')}}>
                        제안수락
                      </button>}
                      {singleApply.step === "검토" &&
                      <button onClick={()=>{fetchAccept("추천수락"); history.push('/applylist')}}>
                        제안수락
                      </button>}
                      {singleApply.step === "기간만료" &&
                      <button onClick={()=>{fetchApply(); history.push('/applylist')}}>
                        지원하기
                      </button>}
                      
                    </>
                    
                  :
                    <button onClick={()=>{fetchApply(); history.push('/profile')}}>
                      지원하기
                    </button>
                  }
                </ButtonForm>
              </AfterRight>
              :
              <AfterRight>
                이력서가 없어요!
                <ButtonForm>
                  
                  <button onClick={()=>{history.push('/profile')}}>
                    이력서 작성하기
                  </button>
                </ButtonForm>
              </AfterRight>
          :
            <BeforeRight>
              
              <div>
                <h3>채용보상금</h3>
                <ul>
                  <li>
                    <div>
                      추천인
                    </div>
                    <div>
                      500,000 원
                    </div>
                  </li>
                  <li>
                    <div>
                      지원자
                    </div>
                    <div>
                      500,000 원
                    </div>
                  </li>
                </ul>
              </div>

              {user?

                <ButtonForm>
                  <button onClick={()=>{console.log("bookmark api")}}>
                      북마크하기
                  </button>
                  {singleApply?
                    <>

                      {singleApply.step === "지원완료" && 
                      <button disabled>지원완료</button>}
                      {singleApply.step === null && 
                      <button disabled>지원완료</button>}
                      {/* {singleApply.step === "추천" && "지원완료"} */}
                      {singleApply.step === "최종합격" && 
                      null}
                      {singleApply.step === "서류합격" && 
                      <button disabled>서류합격</button>}
                      
                      {/* {singleApply.step === "제안보냄" && 
                        <>
                        <button onClick={()=>{fetchAccept("제안수락"); history.push('/applylist')}}>
                          지원하기
                        </button> <p>"이 회사가 나를 좋아해요!"</p> </>}
                       */}
                      {singleApply.step === "제안보냄" && 
                        <button onClick={()=>{fetchAccept("제안수락"); history.push('/applylist')}}>
                          제안수락
                        </button>}

                      {singleApply.step === "추천제안" && 
                      <button onClick={()=>{fetchAccept("추천수락"); history.push('/applylist')}}>
                        제안수락
                      </button>}
                      {singleApply.step === "기간만료" &&
                      <button onClick={()=>{setApplycheck(true)}}>
                        지원하기
                      </button>}
                      
                    </>
                    
                  :
                    <button onClick={()=>{setApplycheck(true)}}>
                      지원하기
                    </button>
                  }
                  {ra? ra.status !== "7%" &&
                    <button onClick={()=>{console.log("문의하기 api")}}>
                      문의하기
                    </button>
                    : null
                  }
                </ButtonForm>
              :
                <ButtonForm>
                <button onClick={()=>actions.setIsShowing(!state.isShowing)}>
                    로그인
                </button>
                </ButtonForm>
              }

              
            </BeforeRight>
          }
          </RightForm>
          </>
          :null}
        </RaWrapper>
      </Wrapper>   
      {/* } */}
    </>
  )
}
const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 50px);
  margin-top: 45px;
  display: block;
  position: relative;
`

const RaWrapper = styled.div`
  max-width: 1060px;
  width: 90%;
  display: block;
  margin: 0 auto;
  background-color: whitesmoke;
`

const CompanyWrapper = styled.div`
  /* max-width: 1060px; */
  width: 100%;
  display: flex;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, .8);
  height: 300px;

  border-bottom: 1px solid rgba(0,0,0,0.2);
  margin-bottom: 10px;

  justify-content: center;
  align-items: center;

  >div{
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    >div{
      
      :first-child{
        width: 100px;
        height: 100px;
        /* background-position-x:50%;
        background-position-y:50%;
        background-size: cover; */
        margin-bottom: 5px;
        position: relative;

        display: flex;
        justify-content: center;
        align-items: center;

        overflow:hidden;

        img{
          width: 100%;
          background-position-x:50%;
          background-position-y:50%;
          background-size: cover;
        }
        /* .logo{
          display: flex;
          justify-content: center;
          align-items: center;
          
          
        } */
        
      }
      :nth-child(2){
        width: 100%;
        height: 20px;
        margin-bottom: 5px;
        position: relative;
        >a{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
      :last-child{
        display: block;
        >div{
          display: inline-block;
          font-size: 0.8rem;
          border: .5px solid rgba(0,0,0,0.2);
          border-radius: 12px;
          padding: 7px;
          padding-left: 10px;
          padding-right: 10px;
          margin: 5px;
        }
      }
    }

  }
`

const RaForm = styled.div`
  width: 65%;
  box-sizing: border-box;
  padding: 5px;
  padding-left: 0px;
  display: inline-block;
  margin: 0;
  
  text-align: left;
  vertical-align: top;

  >div{
    width: 100%;
    /* background-color: rgba(255, 255, 255, 0.8); */
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 5px;
    border: .5px solid rgba(0,0,0,0.2);
    box-sizing: border-box;
    padding: 10px;

    .main{
      display: flex;
      justify-content: center;
      align-items: center;

      height: 400px;

      overflow: hidden;
      margin: -10px;
      border-radius: 5px 5px 0px 0px;
      >img{
        width: 100%;
        background-position-x:50%;
        background-position-y:50%;
        background-size: cover;
      }
    }
    
    .ra-header{
      margin-top: 40px;
      margin-bottom: 40px;
      h1, h4, p{
        margin: 0px;
        margin-bottom: 10px;
      }
      h4, p{
        display: inline-block;
        margin-right: 10px;
      }
      p{
        font-size: 0.8rem;
        color: rgba(0,0,0,0.6);
      }
      >div{
        >div{
          display: inline-block;
          font-size: 0.8rem;
          /* border: .5px solid rgba(0,0,0,0.2); */
          border-radius: 12px;
          padding: 7px;
          padding-left: 10px;
          padding-right: 10px;
          margin-right: 7px;
          background-color: rgba(0,0,0,0.05);
        }
      }
    }
    .ra-field{
      margin-top: 40px;
      margin-bottom: 40px;
      >div{
        margin-top: 20px;
        margin-bottom: 20px;

        >span{
          :first-child{
            display: inline-block;
            width: 150px;
            margin-right: 50px;
            color: rgba(0,0,0,0.6);
            font-weight: bold;
          }
          :last-child{
            /* color: rgba(0,0,0,0.8); */
            font-weight: bold;
          }
        }
      }
    }
    .ra-body{

    }
  }
`


const RightForm = styled.div`
  width: 35%;
  box-sizing: border-box;
  padding: 5px;
  padding-right: 0px;
  display: inline-block;
  margin: 0;
  
  text-align: left;
  vertical-align: top;
  
`

const BeforeRight = styled.div`
  min-height: 350px;
  height: auto;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  border: .5px solid rgba(0,0,0,0.2);
  position: relative;
  box-sizing: border-box;
  padding: 20px;

  >div{
    >h3{
      margin-top: 0;
    }
    >ul{
      list-style: none;
      display: block;
      margin: 0;
      padding: 0;
      padding-top: 20px;
      >li{
        display: inline-block;
        width: 50%;
        >div{
          margin-bottom: 10px;
          :first-child{
            font-size: 0.9rem;
            color: rgba(0,0,0,0.7);
          }
          :last-child{
            font-weight: bold;
          }
        }
      }
    }
  }
`

const AfterRight = styled.div`
  height: 500px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  border: .5px solid rgba(0,0,0,0.2);
  position: relative;
  box-sizing: border-box;
  padding: 20px;
  h3{
    margin-top: 0;
  }
`

const ResumeForm = styled.div`
  width: 100%;
  display: block;
  /* flex-direction: column; */
  max-height: 320px;
  overflow: auto;

  .active{
      opacity:1;
    }
  .deactive{
    opacity:.6;
    background-color: rgba(0,0,0,0.2);
  }
  >span{
    width: 100%;
    border: .5px solid rgba(0,0,0,0.2);
    padding: 0px;
    display: block;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  >div{
    display: block;
    margin-left: 2px;
    >div{
      display: block;
      border: .5px solid rgba(0,0,0,0.2);
      border-radius: 5px;
      height: 50px;
      margin-bottom: 10px;
      padding: 5px;
    }
  }
`

const ButtonForm = styled.div`
  width: calc(100% - 40px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 20px;
  >button{
    
    
    :last-child,  :nth-last-child(2){
      cursor: pointer;
      margin: 0;
      margin-bottom: 10px;
      width: 100%;
      height: 45px;
      border-radius: 10px;
      background-color: rgba(253,134,18, 0.6);
      border: none;
      color: white;
      font-weight: bold;
      font-size: 1.1rem;
    }
    :first-child{
      cursor: pointer;
      margin: 0;
      margin-bottom: 10px;
      width: 100%;
      height: 45px;
      border-radius: 10px;
      background-color: white;
      border: .5px solid rgba(253,134,18, 0.6);
      color: rgba(253,134,18, 0.8);
      font-weight: bold;
      font-size: 1.1rem;
    }

    :disabled{
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`
export default SingleRa